import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ValidatorForm } from 'react-material-ui-form-validator';
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import DocumentTypeDropDown from '../DropDowns/DocumentTypeDropDown';

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
        padding: '0'
    },
    gridItem: {
        padding: '0'
    },
    buttonItem: {
        marginTop: theme.spacing(2),

    },
    button: {

        //height: '56px'
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    errorText: {
        color: '#ff0000'
    }
});

interface IDocumentUploadTypeSelectionProps {
    setDocType: (docType: number, docTypeText: string) => void;
}

interface IDocumentUploadTypeSelectionState {
    documentType: number | null;
    documentTypeText: string | null;
    saving: boolean;
}

export class DocumentUploadTypeSelection extends Component<IDocumentUploadTypeSelectionProps & WithStyles<typeof styles>, IDocumentUploadTypeSelectionState> {
    constructor(props) {
        super(props);

        this.state = {
            documentType: null,
            documentTypeText: null,
            saving: false,
        };
    }

    public componentDidMount() {
    }

    componentWillUnmount() {
    }

    public render() {
        const classes = this.props.classes;

        return (
            <Grid className={classes.root} container>
                <Grid item xs={12}>
                    <Grid className={classes.root} container>
                        <Grid item xs={12}>
                            <Typography variant="h2">
                                Secure Document Management
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} >
                    <Grid className={this.props.classes.root} container alignItems="center" justify="center">
                        <Grid item xs={12}>
                            <ValidatorForm onSubmit={this.save} autoComplete="off">
                                <Grid className={classes.root} container>
                                    <Grid item xs={12}>
                                        <DocumentTypeDropDown
                                            disabled={false}
                                            documentType={this.state.documentType}
                                            setDocumentType={this.handleDocTypeChange}
                                        />
                                    </Grid>
                                </Grid>            
                                            
                                <Grid item container justify="flex-end" spacing={2}>
                                    <Grid item xs={12} sm={5} md={5} className={classes.buttonItem}>
                                        <Button type="submit" color="primary" variant="contained" className={classes.button} endIcon={<CloudUploadIcon />} fullWidth>
                                            Upload
                                                {this.state.saving && <CircularProgress color='secondary' size={24} className={this.props.classes.buttonProgress} />}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </ValidatorForm>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    public handleDocTypeChange = (event) => {
        if (this.state.documentType !== event.target.value) {
            this.setState({ documentType: event.target.value});
        }
    }

    private save = (event) => {
        event.preventDefault();
        console.log(1);
        this.setState({ saving: true }, () => {
            console.log(2);
            if (this.state.documentType !== null) {
                console.log(3);
                fetch('api/DropDown/GetDocumentTypeText?id=' + this.state.documentType).then(response => response.text()).then((data) => {
                    console.log(4);
                    if (this.state.documentType !== null) {
                        console.log(5);
                        this.props.setDocType(this.state.documentType, data);
                    }
                });
                
            }

            this.setState({ saving: false });
        });
    }
}

export default withStyles(styles)(DocumentUploadTypeSelection);

